module.exports = __webpack_public_path__ + "static/headwindapp-ui-layer-radar-8d22088d894585727598714b5b126c4a.gif";